import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BreakWord extends BaseOption {
  static userInterfaceComponent = {
    label: "Break Words",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "break",
          tooltip: "",
        },
        {
          label: "No",
          value: "standard",
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = "break";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "break";
  }
}
